import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Form, FormGroup, FormControl, InputGroup, Modal, Button } from 'react-bootstrap'
import rest from '../../lib/rest'
import md5 from 'blueimp-md5'
import { UserCheck } from 'styled-icons/fa-solid/UserCheck'
import { Key } from 'styled-icons/fa-solid/Key'
import { Tag } from 'styled-icons/fa-solid/Tag'
import { ArrowLeft } from 'styled-icons/fa-solid/ArrowLeft'


class SignUp extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      user: '',
      name: '',
      nameAlert: '',
      userAlert:'',
      passAlert:'',
      alert: ''
    }
  }

  componentDidMount() {
    this.nameInput.focus()
  }

  goback = () => this.props.onModeChange('signin')

  clearAlert = () => this.setState({ alert: '',  userAlert: '', passAlert: '', nameAlert: '' })
  alert = m => {
    this.setState({ alert: m })
    setTimeout(this.clearAlert, 3000)
  }

  setValue = e => this.setState({ [e.target.id]: e.target.value })
  onEnter = e => (e.charCode === 13) ? this.submit(e) : null

  submit = e => {
    e.preventDefault()

    const { name, user } = this.state
    if (!name) {
      this.nameInput.focus()
      return this.setState({ nameAlert: 'Name required', userAlert: '', passAlert: '' })
    }
    if (!user) {
      this.userInput.focus()
      return this.setState({ nameAlert: '', userAlert: 'user id required', passAlert: '' })
    }
    const pass = this.passInput.value
    if (!pass) {
      this.passInput.focus()
      return this.setState({ nameAlert: '', userNotice: '', passAlert: 'password required' })
    }

    const data = JSON.stringify({
      users : [{ user: user, password: md5(pass), description: name }]
    })
    rest.userCreate(data).then(res => {
      if (res.status === 'fail') {
        this.alert(res.error)
      } else {
        this.goback()
      }
    })
  }

  render() {
    const { name, user, nameAlert, userAlert, passAlert, alert } = this.state

    return (
      <Modal.Dialog dialogClassName='modal-login'>
        <div className='text-xs-center bg-info p-y-4'>
          <span className='font-size-18 line-height-1'>Create an account</span>
        </div>
        { !!alert ? <div className='alert alert-danger'>{alert}</div> : null }

        <Form className='p-a-4'>
          <FormGroup controlId='name' className={ cx({ 'has-warning': !!nameAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><Tag size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.nameInput = r} autoComplete='off' type='text' value={name}
                placeholder='name' onChange={this.setValue} onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{nameAlert}</small>
          </FormGroup>
          <FormGroup controlId='user' className={ cx({ 'has-warning': !!userAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><UserCheck size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.userInput = r} autoComplete='off' type='text' value={user}
                placeholder='user id' onChange={this.setValue} onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{userAlert}</small>
          </FormGroup>

          <FormGroup className={ cx({ 'has-warning': !!passAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><Key size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.passInput = r} type='password' placeholder='password' onChange={this.setValue} onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{passAlert}</small>
          </FormGroup>

          <Button bsSize='lg' bsStyle='info' className='btn-block m-t-3' onClick={this.submit}>Sign Up</Button>
          <Button className='btn-link' onClick={this.goback}><ArrowLeft size={14}/> Back</Button>
        </Form>

      </Modal.Dialog>
    )
  }
}

SignUp.propTypes = {
    strings: PropTypes.object
}

export default SignUp



// WEBPACK FOOTER //
// ./src/components/auth/SignUp.js